import {
  Box,
  Divider,
  Grid,
  IconButton,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import { tokens } from "../../../theme";
import { simpleCardStyle } from "../../../styles/cardStyles";
import styles, { releaseCardStyle } from "../styles";
import { stackCenterGap } from "../../../styles/utilStyles";
import useIamModal from "../../IamModal/UseIamModal";
import { useHasPermission } from "../../../api/iam";
import { getHeaders } from "../../../utils/apiclient";
import ReleasesLabelItem from "./ReleaseLabelItem";
import ActionButton from "./ActionButton";
import { AddCircleOutline, AdminPanelSettings } from "@mui/icons-material";
import { toTitleCase } from "../../../utils/helperFunctions";

const ReleaseCard = ({
  release,
  handlePatchLabel,
  app,
  showReleaseStatusDialog,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const canCreatePatch = useHasPermission(
    `/apps/${app}/releases/${release?.name}/release-labels`,
    "POST",
    "CREATE"
  );

  const { IamModal, openIamModal, canViewIamModal } = useIamModal(
    `/apps/${app}/releases/${release?.name}`
  );

  return (
    <Grid item xs={12}>
      <Box sx={simpleCardStyle(colors)}>
        {IamModal}
        <Box sx={styles.releaseCardHeadingStack}>
          <Typography variant="h3">{release?.name}</Typography>
          {(release?.dynamicStatus || [release?.status])?.map((status) => (
            <Typography variant="h5" sx={releaseCardStyle.status(status)}>
              {toTitleCase(status)?.replace("Qa", "QA")}
            </Typography>
          ))}
          <Box sx={stackCenterGap} />

          {release?.actionsAllowed?.map((action) => (
            <ActionButton
              action={action}
              path={`/apps/${app}/releases/${release?.name}`}
              onClick={() =>
                showReleaseStatusDialog(
                  `Perform action ${action} on release ${release?.name}`,
                  `/${release?.name}`,
                  { headers: { ...getHeaders(), Action: action } }
                )
              }
            />
          ))}

          {canViewIamModal ? (
            <Tooltip title={<Typography>IAM</Typography>}>
              <IconButton onClick={() => openIamModal()}>
                <AdminPanelSettings />
              </IconButton>
            </Tooltip>
          ) : (
            <></>
          )}
          {release?.status === "CREATED" ||
          release?.status === "OUT_OF_RELEASE_CYCLE" ? (
            <Tooltip title={<Typography>Create Release Label</Typography>}>
              <IconButton
                onClick={(event) => {
                  event.stopPropagation();
                  if (release?.name) {
                    handlePatchLabel(release.name, canCreatePatch);
                  }
                }}
              >
                <AddCircleOutline />
              </IconButton>
            </Tooltip>
          ) : (
            <></>
          )}
        </Box>
        <Divider />

        {release?.releaseLabels
          ?.map((releaseLabel) =>
            releaseLabel?.highlight ? (
              <ReleasesLabelItem
                release={release}
                releaseLabel={releaseLabel}
                app={app}
                showReleaseStatusDialog={showReleaseStatusDialog}
              />
            ) : null
          )
          ?.filter(Boolean)}
      </Box>
    </Grid>
  );
};

export default ReleaseCard;
